export default __webpack_public_path__ + "static/media/home-qualification11mobile.b27d858c.png";